<script setup>
import { defineProps, defineEmits, computed} from "vue";
import UtilMoney from "../../../../utils/UtilMoney";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
    "contaAPagar",
]);

const emits = defineEmits([
    "update:alteraContaAPagar",
]);


//==================================================================//
//==================== Altera Conta a Pagar ========================//
//==================================================================//

const alteraContaAPagar = (update = {})=>{

    emits('update:alteraContaAPagar',update);

};

//==================================================================//
//================ Ao Selecionar Conta a Pagar =====================//
//==================================================================//

const aoSelecionarContaAPagar = ()=>{

    alteraContaAPagar({
        selecionado: !props?.contaAPagar?.selecionado || false,
    })

};

//==================================================================//
//==================== Ao Expandir Pagamentos ======================//
//==================================================================//

const aoExpandirPagamentos = ()=>{

    alteraContaAPagar({
        aberto: !props?.contaAPagar?.aberto || false,
    })

};

//==================================================================//
//================= Mostra Expandir Pagamentos =====================//
//==================================================================//

let mostraExpandirPagamentos = computed(()=>{

    if(props?.contaAPagar?.pagamentosQuantidade <= 0){
        return false;
    }

    return true;

});

</script>

<template>

    <div class="c-table__row">

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <div class="c-controles">

                    <v-checkbox
                        class="c-checkbox"
                        :value="props?.contaAPagar?.selecionado"
                        :disabled="props?.controlesDesativados"
                        @change="aoSelecionarContaAPagar"
                    ></v-checkbox>

                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                v-show="mostraExpandirPagamentos"
                                class="c-botao-expandir-pagamentos mx-2"
                                fab
                                dark
                                small
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                :disabled="props?.controlesDesativados"
                                @click="aoExpandirPagamentos"
                            >

                                <v-icon
                                    v-if="props?.contaAPagar?.aberto == false"
                                    dark
                                >
                                    mdi-chevron-down
                                </v-icon>

                                <v-icon
                                    v-else
                                    dark
                                >
                                    mdi-chevron-up
                                </v-icon>

                            
                            </v-btn>

                        </template>

                        <span>Visualizar os Pagamentos</span>

                    </v-tooltip>

                </div>

            </div>

        </div>

        
        <div class="c-table__cell c-table__cell">

            <div class="c-table__cell-content">

                <v-chip
                    color="#dedede"
                    label
                    dark
                >

                    <v-icon left color="#565656">
                        mdi-receipt-text
                    </v-icon>

                    <span
                        class="c-table__cell-content-text"
                    >

                        {{props?.contaAPagar?.codigo}}

                    </span>

                </v-chip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.contaAPagar?.status}}

            </div>

        </div>
 
        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.contaAPagar?.forma}}

            </div>

        </div>

        
        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.contaAPagar?.tipo}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.contaAPagar?.evento}}

            </div>

        </div>


        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.contaAPagar?.descricao}}

            </div>

        </div>

        
        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.contaAPagar?.dataVencimento}}

            </div>

        </div>

        
        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.contaAPagar?.valorOriginal)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.contaAPagar?.valorParaReservar)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.contaAPagar?.valorDesconto)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.contaAPagar?.valorPagamento)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.contaAPagar?.valorReservado)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.contaAPagar?.valorParaPagar)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.contaAPagar?.valorPago)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.contaAPagar?.valorParaVincular)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.contaAPagar?.valorVinculado)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.contaAPagar?.liberadorNome}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.contaAPagar?.aprovadorNome}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.contaAPagar?.reprovadorNome}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.contaAPagar?.reprovadorJustificativa}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content"></div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: contents;
}

.c-table__row:hover > .c-table__cell{
    background-color: #eeeeee;
}

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__cell--principal{
    border-left: 10px solid #1976d2;
    border-radius: 5px;
}

.c-table__cell-content-text{
    color: #565656;
    font-weight: 600;
}

.c-controles{
    display: flex;
    align-items: center;
    gap: 20px;
}

.c-checkbox >>> .v-icon{
    font-size: 26px;
}

.c-checkbox >>> .v-input--selection-controls__input{
    margin: 0px;
}

.c-checkbox.v-input--is-label-active >>> .v-input--selection-controls__ripple{
    color: #1976d2 !important;
    caret-color: #1976d2 !important;
}

.c-checkbox.v-input--is-label-active >>> .v-icon{
    color: #1976d2 !important;
    caret-color: #1976d2 !important;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-expandir-pagamentos{
    background: #3F51B5 !important;
    border-color: #3F51B5 !important;
}

</style>